import { VariantProps, cva } from 'class-variance-authority';

export const featuredIconStyles = cva(
  'inline-flex items-center justify-center',
  {
    variants: {
      variant: {
        'light-circle': 'rounded-full',
        'light-circle-outline': 'rounded-full',
        'dark-circle': 'rounded-full',
        'light-square': 'bg-primary50 fill-primaryMain',
        'mid-square': 'bg-primary400 fill-grayscale0',
        'dark-square': 'bg-primaryMain fill-grayscale0',
        modern: 'bg-grayscale0 border border-grayscale100 fill-primaryMain',
      },
      color: {
        primary: '',
        gray: '',
        error: '',
        warning: '',
        success: '',
      },
      size: {
        xs: 'min-w-24 w-24 h-24',
        sm: 'min-w-32 w-32 h-32',
        md: 'min-w-40 w-40 h-40',
        lg: 'min-w-48 w-48 h-48',
        xl: 'min-w-56 w-56 h-56',
      },
    },
    compoundVariants: [
      // Light Circle and Light Circle Outline
      {
        variant: ['light-circle', 'light-circle-outline'],
        color: 'primary',
        className: 'outline-primary50 bg-primary50 fill-primaryMain',
      },
      {
        variant: ['light-circle', 'light-circle-outline'],
        color: 'gray',
        className: 'outline-grayscale50 bg-grayscale50 fill-grayscale400',
      },
      {
        variant: ['light-circle', 'light-circle-outline'],
        color: 'error',
        className: 'outline-error50 bg-error50 fill-error300',
      },
      {
        variant: ['light-circle', 'light-circle-outline'],
        color: 'warning',
        className: 'outline-warning50 bg-warning50 fill-warning300',
      },
      {
        variant: ['light-circle', 'light-circle-outline'],
        color: 'success',
        className: 'outline-success50 bg-success50 fill-success300',
      },

      // Light Circle Outline
      {
        variant: 'light-circle-outline',
        size: 'xl',
        className: 'outline outline-10',
      },
      {
        variant: 'light-circle-outline',
        size: 'lg',
        className: 'outline outline-8',
      },
      {
        variant: 'light-circle-outline',
        size: 'md',
        className: 'outline outline-6',
      },
      {
        variant: 'light-circle-outline',
        size: 'sm',
        className: 'outline outline-4',
      },
      {
        variant: 'light-circle-outline',
        size: 'xs',
        className: 'outline outline-2',
      },

      // dark-circle
      {
        variant: 'dark-circle',
        color: 'primary',
        className: 'bg-primaryMain fill-grayscale0',
      },
      {
        variant: 'dark-circle',
        color: 'gray',
        className: 'bg-grayscale500 fill-grayscale0',
      },
      {
        variant: 'dark-circle',
        color: 'error',
        className: 'bg-error300 fill-grayscale0',
      },
      {
        variant: 'dark-circle',
        color: 'warning',
        className: 'bg-warning300 fill-grayscale0',
      },
      {
        variant: 'dark-circle',
        color: 'success',
        className: 'bg-success300 fill-grayscale0',
      },

      // Square
      {
        variant: ['light-square', 'mid-square', 'dark-square', 'modern'],
        size: 'xl',
        className: 'rounded-12',
      },
      {
        variant: ['light-square', 'mid-square', 'dark-square', 'modern'],
        size: 'lg',
        className: 'rounded-10',
      },
      {
        variant: ['light-square', 'mid-square', 'dark-square', 'modern'],
        size: 'md',
        className: 'rounded-8',
      },
      {
        variant: ['light-square', 'mid-square', 'dark-square', 'modern'],
        size: 'sm',
        className: 'rounded-6',
      },
      {
        variant: ['light-square', 'mid-square', 'dark-square', 'modern'],
        size: 'xs',
        className: 'rounded-4',
      },
    ],
    defaultVariants: {
      variant: 'light-circle',
      color: 'primary',
    },
  },
);

export type FeaturedIconStyleVariants = VariantProps<typeof featuredIconStyles>;
